import React from 'react'
import { QuestionOptionIcon, getQuestionOptionIndex } from '../../utils'
import { QuestionChoice } from '@mission.io/question-toolkit'
import { QuestionResponseStyled } from '../../assets/styles'
import OptionalMarkdown from '../Markdown/OptionalMarkdown'
import classNames from 'classnames'

/**
 * This function makes the Choices Response box for Analytics Student answer.
 * We show each question answer option, and style it as needed.
 */
export default function ChoicesResponse({
	choices,
	studentChoiceSelected,
	iconPrepend,
}: {
	choices: QuestionChoice[]
	studentChoiceSelected?: string | string[]
	iconPrepend?: boolean
}): JSX.Element {
	if (!choices || choices.length === 0) {
		return <>No question options to show</>
	}

	const someChoiceHasText = choices.some(
		(choice: QuestionChoice) => choice?.text !== ''
	)

	return (
		<QuestionResponseStyled>
			<ul>
				{choices.map((choice: QuestionChoice, index: number) => {
					const studentChoice = Array.isArray(studentChoiceSelected)
						? studentChoiceSelected.indexOf(String(choice._id)) > -1
						: String(choice._id) === String(studentChoiceSelected)
					const image = choice.media?.[0]?.url

					return (
						<li
							className={classNames(
								'flex items-center',
								choice.answer ? 'text-success' : studentChoice && 'text-error'
							)}
							key={String(choice._id) || `${index}-question-option`}>
							<QuestionOptionIcon
								studentChoice={studentChoice}
								correctOption={choice.answer}
							/>
							{iconPrepend && (
								<span className={`square ${studentChoice ? 'selected' : ''}`} />
							)}
							<div className="flex flex-row items-center">
								<div className="notranslate">
									{getQuestionOptionIndex(index) + ':'}
								</div>
								<div className="ml-2">
									{someChoiceHasText ? (
										choice.text ? (
											<OptionalMarkdown>{choice.text}</OptionalMarkdown>
										) : (
											'(No text provided)'
										)
									) : (
										''
									)}
								</div>
							</div>
							{image && (
								<img
									alt={`Choice Image ${index}`}
									src={image}
									className="ml-2 h-[100px] w-auto"
								/>
							)}
						</li>
					)
				})}
			</ul>
		</QuestionResponseStyled>
	)
}
